import React from 'react'
import styled from 'styled-components'

import { Button, FormField } from 'components'

const Container = styled.div`
    display: grid;
    grid-template-columns: 100%;
    grid-template-rows: auto auto;
    grid-gap: 0.5rem;
    margin-top: 0.2rem;
`

const ButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    grid-column: 1/ span 2;
`

const EmailInput = props => {
    const {
        email,
        onSubmit,
        onCancel
    } = props;
    const [value, setValue] = React.useState(email)
    const [error, setError] = React.useState(null)
    const [focus, setFocus] = React.useState(false)

    const onKeyDownHandler = (event) => {
        if (event.keyCode === 13 ) {
            submitForm()
        }
    }

    const submitForm = ()  => {
        // Email
        const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if(!value){
            setError('Please enter your email')
        } else if (!re.test(value)){
            setError('Please enter a valid email')
        } else {
            onSubmit && onSubmit(value)
        }
    }

    return (
        <Container>
            <FormField type='TEXT' value={value} error={error} selected={focus} style={{margin: 0, labelWeight: 'normal'}}
                onFocus={() => setFocus(true)} onBlur={() => setFocus(false)}
                onChange={(value) => setValue(value)} onKeyDown={onKeyDownHandler}/>
            
            {/* Buttons */}
            <ButtonContainer>
                <Button text='Cancel' styles={{backgroundColor:'var(--primary-color)', margin: '0 0.5rem', boxShadowColor: 'transparent'}} onSelect={onCancel}/>
                <Button text='Save' styles={{backgroundColor: 'var(--focus-color)', margin: 0, color: 'white'}} onSelect={submitForm}/>
            </ButtonContainer>
        </Container>
    )
    
}

export default EmailInput;